import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import cx from 'classnames';
import { Card, CardBody } from 'reactstrap';
import { keyBy } from 'lodash';
import { hierarchy } from '@visx/hierarchy';
import assessmentTemplates from 'js/data/assessment-templates';
import {
  createOrgAssessmentWeightContext,
  enrichFlatScoresWithQuestionSetRollups,
  rollupChildQuestionSetScores,
  rollupChildScoreMaps,
} from 'js/utils/org-assessment-rollup';
import ScorecardNode from './ScorecardNode';
import ScorecardHeaderCell from './ScorecardHeaderCell';
import SquadScorecardScrollArrow from './SquadScorecardScrollArrow';
import {
  buildScorecardColumnData,
  questionSetRollupsFromColumnData,
} from './columnData';

// const mockOrg = {
//   type: 'root',
//   name: 'Workspace name',
//   child_orgs: [
//     {
//       name: 'Provider',
//       child_orgs: [],
//       teams: [
//         { id: 1, name: 'Provider - Team 1' },
//         { id: 2, name: 'Provider - Team 2' },
//         { id: 3, name: 'Provider - Team 3' },
//       ],
//     },
//     {
//       name: 'Childless',
//       child_orgs: [],
//       teams: [],
//     },
//     {
//       type: 'group',
//       name: 'Member',
//       child_orgs: [
//         {
//           type: 'group',
//           name: 'Member - Train 1',
//           child_orgs: [],
//           teams: [
//             { id: 3, name: 'Member - Team 1' },
//             { id: 4, name: 'Member - Team 2' },
//           ],
//         },
//         {
//           name: 'Member - Train 2',
//           child_orgs: [
//             {
//               name: 'Member - Subtrain 2a',
//               child_orgs: [],
//               teams: [
//                 { id: 7, name: 'Member - Team 5' },
//                 { id: 8, name: 'Member - Team 6' },
//               ],
//             },
//           ],
//           teams: [
//             { id: 5, name: 'Member - Team 3' },
//             { id: 6, name: 'Member - Team 4' },
//           ],
//         },
//       ],
//       teams: [],
//     },
//   ],
//   teams: [],
// };

// const mockScores = [
//   {
//     node_id: 1,
//     node_name: 'Sketch',
//     node_type: 'team',
//     question_scores: [
//       { score: 0.42, question_key: 'delivering-value', question_set_key: 'squad-health-check' },
//       { score: 0.14, question_key: 'easy-to-release', question_set_key: 'squad-health-check' },
//       { score: 0.78, question_key: 'fun', question_set_key: 'squad-health-check' },
//       { score: 0.37, question_key: 'health-of-codebase', question_set_key: 'squad-health-check' },
//       { score: 0.50, question_key: 'learning', question_set_key: 'squad-health-check' },
//       { score: 0.50, question_key: 'mission', question_set_key: 'squad-health-check' },
//       { score: 0.14, question_key: 'pawns-or-players', question_set_key: 'squad-health-check' },
//       { score: 0.64, question_key: 'speed', question_set_key: 'squad-health-check' },
//       { score: 0.21, question_key: 'suitable-process', question_set_key: 'squad-health-check' },
//       { score: 0.64, question_key: 'support', question_set_key: 'squad-health-check' },
//       { score: 0.71, question_key: 'teamwork', question_set_key: 'squad-health-check' },
//     ],
//   },
//   {
//     node_id: 2,
//     node_name: 'Testing team',
//     node_type: 'team',
//     question_scores: [
//       { score: 0.50, question_key: 'teamwork', question_set_key: 'squad-health-check' },
//     ],
//   },
//   {
//     node_id: 3,
//     node_name: 'Sketch',
//     node_type: 'team',
//     question_scores: [
//       { score: 0.42, question_key: 'delivering-value', question_set_key: 'squad-health-check' },
//       { score: 0.14, question_key: 'easy-to-release', question_set_key: 'squad-health-check' },
//       { score: 0.78, question_key: 'fun', question_set_key: 'squad-health-check' },
//       { score: 0.37, question_key: 'health-of-codebase', question_set_key: 'squad-health-check' },
//       { score: 0.50, question_key: 'learning', question_set_key: 'squad-health-check' },
//       { score: 0.50, question_key: 'mission', question_set_key: 'squad-health-check' },
//       { score: 0.14, question_key: 'pawns-or-players', question_set_key: 'squad-health-check' },
//       { score: 0.64, question_key: 'speed', question_set_key: 'squad-health-check' },
//       { score: 0.21, question_key: 'suitable-process', question_set_key: 'squad-health-check' },
//       { score: 0.64, question_key: 'support', question_set_key: 'squad-health-check' },
//       { score: 0.71, question_key: 'teamwork', question_set_key: 'squad-health-check' },
//     ],
//   },
//   {
//     node_id: 4,
//     node_name: 'Sketch',
//     node_type: 'team',
//     question_scores: [
//       { score: 0.42, question_key: 'delivering-value', question_set_key: 'squad-health-check' },
//       { score: 0.14, question_key: 'easy-to-release', question_set_key: 'squad-health-check' },
//       { score: 0.78, question_key: 'fun', question_set_key: 'squad-health-check' },
//       { score: 0.37, question_key: 'health-of-codebase', question_set_key: 'squad-health-check' },
//       { score: 0.50, question_key: 'learning', question_set_key: 'squad-health-check' },
//       { score: 0.50, question_key: 'mission', question_set_key: 'squad-health-check' },
//       { score: 0.14, question_key: 'pawns-or-players', question_set_key: 'squad-health-check' },
//       { score: 0.64, question_key: 'speed', question_set_key: 'squad-health-check' },
//       { score: 0.21, question_key: 'suitable-process', question_set_key: 'squad-health-check' },
//       { score: 0.64, question_key: 'support', question_set_key: 'squad-health-check' },
//       { score: 0.71, question_key: 'teamwork', question_set_key: 'squad-health-check' },
//     ],
//   },
//   {
//     node_id: 8,
//     node_name: 'Sketch',
//     node_type: 'team',
//     question_scores: [
//       { score: 0.42, question_key: 'delivering-value', question_set_key: 'squad-health-check' },
//       { score: 0.14, question_key: 'easy-to-release', question_set_key: 'squad-health-check' },
//       { score: 0.78, question_key: 'fun', question_set_key: 'squad-health-check' },
//       { score: 0.37, question_key: 'health-of-codebase', question_set_key: 'squad-health-check' },
//       { score: 0.50, question_key: 'learning', question_set_key: 'squad-health-check' },
//       { score: 0.50, question_key: 'mission', question_set_key: 'squad-health-check' },
//       { score: 0.14, question_key: 'pawns-or-players', question_set_key: 'squad-health-check' },
//       { score: 0.64, question_key: 'speed', question_set_key: 'squad-health-check' },
//       { score: 0.21, question_key: 'suitable-process', question_set_key: 'squad-health-check' },
//       { score: 0.64, question_key: 'support', question_set_key: 'squad-health-check' },
//       { score: 0.71, question_key: 'teamwork', question_set_key: 'squad-health-check' },
//     ],
//   },
//   {
//     node_id: 1,
//     node_name: 'Sketch',
//     node_type: 'team',
//     question_scores: [
//       { score: 0.42, question_key: 'delivering-value', question_set_key: 'squad-health-check' },
//       { score: 0.14, question_key: 'easy-to-release', question_set_key: 'squad-health-check' },
//       { score: 0.78, question_key: 'fun', question_set_key: 'squad-health-check' },
//       { score: 0.37, question_key: 'health-of-codebase', question_set_key: 'squad-health-check' },
//       { score: 0.50, question_key: 'learning', question_set_key: 'squad-health-check' },
//       { score: 0.50, question_key: 'mission', question_set_key: 'squad-health-check' },
//       { score: 0.14, question_key: 'pawns-or-players', question_set_key: 'squad-health-check' },
//       { score: 0.64, question_key: 'speed', question_set_key: 'squad-health-check' },
//       { score: 0.21, question_key: 'suitable-process', question_set_key: 'squad-health-check' },
//       { score: 0.64, question_key: 'support', question_set_key: 'squad-health-check' },
//       { score: 0.71, question_key: 'teamwork', question_set_key: 'squad-health-check' },
//     ],
//   },
// ];

const buildNode = (
  orgNode,
  teamData,
  weightContext,
  pathToNode = [],
  questionSetRollups = []
) => {
  const isRoot = orgNode.is_root ?? orgNode.isRoot ?? false;
  const orgRow = { ...orgNode, type: 'org', isRoot };
  const childPath = [...pathToNode, orgRow];

  const orgNodes = orgNode.child_orgs.map((node) =>
    buildNode(node, teamData, weightContext, childPath, questionSetRollups)
  );
  const teamNodes = orgNode.teams.map((team) => ({
    id: team.id,
    name: team.name,
    type: 'team',
    scores: enrichFlatScoresWithQuestionSetRollups(
      keyBy(
        teamData[team.id]?.scores ?? [],
        ({ question_key, question_set_key }) =>
          `${question_set_key}|${question_key}`
      ),
      questionSetRollups
    ),
  }));
  const children = [...orgNodes, ...teamNodes];

  const scores = {
    ...rollupChildScoreMaps(children, weightContext, childPath),
    ...rollupChildQuestionSetScores(
      children,
      weightContext,
      childPath,
      questionSetRollups
    ),
  };

  return {
    ...orgNode,
    type: 'org',
    isRoot,
    children,
    scores,
  };
};

function resolveAssessmentTemplate(assessmentKey, templates) {
  const fromProps = templates?.find(
    (t) => (t.key ?? t.assessment?.key) === assessmentKey
  );
  if (fromProps) {
    return fromProps;
  }

  return assessmentTemplates.find(({ key }) => key === assessmentKey) ?? null;
}

const SquadScorecard = ({
  organization,
  questionScores,
  assessmentKey,
  templates = [],
}) => {
  const teamScores = useMemo(
    () => keyBy(questionScores, 'team_id'),
    [questionScores]
  );

  const columnData = useMemo(() => {
    const template = resolveAssessmentTemplate(assessmentKey, templates);
    return buildScorecardColumnData(
      template?.assessment,
      questionScores,
      template
    );
  }, [assessmentKey, questionScores, templates]);

  const questionSetRollups = useMemo(
    () => questionSetRollupsFromColumnData(columnData),
    [columnData]
  );

  const tree = useMemo(() => {
    const weightContext = createOrgAssessmentWeightContext(organization);
    return hierarchy(
      buildNode(organization, teamScores, weightContext, [], questionSetRollups)
    );
  }, [organization, teamScores, questionSetRollups]);

  const gridStyle = useMemo(
    () => ({
      '--squad-scorecard-question-count': columnData.length,
    }),
    [columnData.length]
  );

  const bodyScrollRef = useRef(null);
  const headerScrollRef = useRef(null);
  const nameColumnRef = useRef(null);
  const scrollSyncRafRef = useRef(null);
  const scrollSourceRef = useRef('body');

  const [scrollMetrics, setScrollMetrics] = useState({
    canScrollLeft: false,
    canScrollRight: false,
    pageScrollWidth: 0,
    nameColumnWidth: 0,
  });

  const syncScrollLeftImmediate = useCallback((source, target) => {
    if (!source || !target || target.scrollLeft === source.scrollLeft) {
      return;
    }
    target.scrollLeft = source.scrollLeft;
  }, []);

  const updateScrollMetrics = useCallback(() => {
    const scrollEl = bodyScrollRef.current;
    const nameEl = nameColumnRef.current;
    if (!scrollEl) {
      return;
    }

    const nameColumnWidth = nameEl?.offsetWidth ?? 0;
    const pageScrollWidth = Math.max(0, scrollEl.clientWidth - nameColumnWidth);
    const maxScrollLeft = scrollEl.scrollWidth - scrollEl.clientWidth;
    const hasOverflow = maxScrollLeft > 1;

    const nextMetrics = {
      canScrollLeft: hasOverflow && scrollEl.scrollLeft > 1,
      canScrollRight: hasOverflow && scrollEl.scrollLeft < maxScrollLeft - 1,
      pageScrollWidth,
      nameColumnWidth,
    };

    setScrollMetrics((prev) => {
      if (
        prev.canScrollLeft === nextMetrics.canScrollLeft &&
        prev.canScrollRight === nextMetrics.canScrollRight &&
        prev.pageScrollWidth === nextMetrics.pageScrollWidth &&
        prev.nameColumnWidth === nextMetrics.nameColumnWidth
      ) {
        return prev;
      }

      return nextMetrics;
    });
  }, []);

  const scheduleScrollSync = useCallback(
    (source) => {
      scrollSourceRef.current = source;

      if (scrollSyncRafRef.current != null) {
        cancelAnimationFrame(scrollSyncRafRef.current);
      }

      scrollSyncRafRef.current = requestAnimationFrame(() => {
        scrollSyncRafRef.current = null;

        const isHeaderSource = scrollSourceRef.current === 'header';
        const sourceEl = isHeaderSource
          ? headerScrollRef.current
          : bodyScrollRef.current;
        const targetEl = isHeaderSource
          ? bodyScrollRef.current
          : headerScrollRef.current;

        syncScrollLeftImmediate(sourceEl, targetEl);
        updateScrollMetrics();
      });
    },
    [syncScrollLeftImmediate, updateScrollMetrics]
  );

  const handleBodyScroll = useCallback(() => {
    scheduleScrollSync('body');
  }, [scheduleScrollSync]);

  const handleHeaderScroll = useCallback(() => {
    scheduleScrollSync('header');
  }, [scheduleScrollSync]);

  const scrollByPage = useCallback(
    (direction) => {
      const scrollEl = bodyScrollRef.current;
      if (!scrollEl || scrollMetrics.pageScrollWidth <= 0) {
        return;
      }

      const delta =
        direction === 'left'
          ? -scrollMetrics.pageScrollWidth
          : scrollMetrics.pageScrollWidth;

      scrollEl.scrollBy({ left: delta, behavior: 'smooth' });
    },
    [scrollMetrics.pageScrollWidth]
  );

  useLayoutEffect(() => {
    syncScrollLeftImmediate(bodyScrollRef.current, headerScrollRef.current);
    updateScrollMetrics();
  }, [syncScrollLeftImmediate, updateScrollMetrics, columnData.length, tree]);

  useEffect(() => {
    const scrollEl = bodyScrollRef.current;
    const nameEl = nameColumnRef.current;
    if (!scrollEl) {
      return undefined;
    }

    const observer = new ResizeObserver(() => updateScrollMetrics());
    observer.observe(scrollEl);
    if (nameEl) {
      observer.observe(nameEl);
    }

    return () => {
      observer.disconnect();
      if (scrollSyncRafRef.current != null) {
        cancelAnimationFrame(scrollSyncRafRef.current);
      }
    };
  }, [updateScrollMetrics, columnData.length]);

  return (
    <Card>
      <CardBody>
        <div className="squad-scorecard">
          <div
            className="squad-scorecard-header-sticky"
            style={{
              '--squad-scorecard-name-width': `${scrollMetrics.nameColumnWidth}px`,
            }}
          >
            <SquadScorecardScrollArrow
              direction="left"
              visible={scrollMetrics.canScrollLeft}
              onClick={() => scrollByPage('left')}
            />
            <SquadScorecardScrollArrow
              direction="right"
              visible={scrollMetrics.canScrollRight}
              onClick={() => scrollByPage('right')}
            />
            <div
              className="squad-scorecard-header-scroll"
              ref={headerScrollRef}
              onScroll={handleHeaderScroll}
            >
              <div
                className="squad-scorecard-grid"
                role="rowgroup"
                style={gridStyle}
              >
                <div className="squad-scorecard-header" role="row">
                  <div className="squad-scorecard-name" ref={nameColumnRef} />
                  {columnData.map((column) => (
                    <ScorecardHeaderCell key={column.combinedKey} {...column} />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="squad-scorecard-body-scroll">
            {scrollMetrics.canScrollRight ? (
              <div
                className="squad-scorecard-scroll-fade squad-scorecard-scroll-fade--right"
                aria-hidden
              >
                <div className="squad-scorecard-scroll-gradient squad-scorecard-scroll-gradient--right" />
              </div>
            ) : null}
            <div
              className="squad-scorecard-scroll-container"
              ref={bodyScrollRef}
              onScroll={handleBodyScroll}
            >
              <div
                className="squad-scorecard-grid t2"
                role="table"
                style={gridStyle}
              >
                <div className="squad-scorecard-grid-body">
                  <div className="squad-scorecard-header-spacer" role="row">
                    <div className="squad-scorecard-name"></div>
                    {columnData.map(({ combinedKey, columnType, text }) => (
                      <div
                        className={cx({
                          'squad-scorecard-question':
                            columnType !== 'questionSet',
                          'squad-scorecard-question-set':
                            columnType === 'questionSet',
                        })}
                        key={combinedKey}
                      >
                        <span className="squad-scorecard-column-name">
                          {text}
                        </span>
                      </div>
                    ))}
                  </div>

                  <ScorecardNode node={tree} columnData={columnData} />
                </div>
              </div>
            </div>
          </div>
          {/* <table className="squad-scorecard-grid">
            <thead>
              <tr>
                <th className="squad-scorecard-name squad-scorecard-header"></th>

                {columnData.map(({ combinedKey, text }) => (
                  <th
                    className="squad-scorecard-question squad-scorecard-header"
                    key={combinedKey}
                  >
                    {text}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <ScorecardNode node={tree} columnData={columnData} />
            </tbody>
          </table> */}
        </div>
      </CardBody>
    </Card>
  );
};

export default SquadScorecard;
